
import * as texto from './texto'



export function formatarSomenteNum(valor){
	
    if(texto.isBlanck(valor))
        return '';

    valor=valor.replace(/\D/g,"");
                                              
    return valor;
}


export function transformaEmNumeroValido(valor){
	
	if(texto.isBlanck(valor))
		return null;

	valor = ""+valor;

	if(valor.includes(",") && valor.includes("."))
		return valor.replace(/\./g, '').replace(',', '.');
		
	if(valor.includes(","))
		return valor.replace(',', '.');
	
	return valor;
}


export function formataNumeroParaMostrar(valor){
	
	if(texto.isBlanck(valor))
		return "0,00";
	
	valor = ""+valor;
	
	if(valor.includes("."))
		valor = valor.replace('.', ',');
	else
		return valor+",00";	

	if(valor.indexOf(",")<0 || valor.indexOf(",") == valor.length-1)
		return valor+"00";	
	
	if(valor.indexOf(",") == valor.length-2)
		return valor+"0";
	
	return valor.substring(0, valor.indexOf(",")+3);
}


export function truncar(valor){
	
	valor = ""+valor;
	
    if(texto.isBlanck(valor))
        return 0;

	let pos = valor.indexOf(".")
    
    if(pos<0)
    	return valor;
 
	return pos< valor.length-2?valor.substring(0, pos+3):valor;
}


export function getInt(valor){
	
	valor = formatarSomenteNum(valor);
	
	if(texto.isBlanck(valor))
		return 0;
	
	return parseInt(valor);
}


export function getFloat(valor){
	
	valor = transformaEmNumeroValido(valor);
	
	if(texto.isBlanck(valor))
		return 0;
	
	return parseFloat(valor);
}